import { render, staticRenderFns } from "./ProductBaseStock.vue?vue&type=template&id=433bf7f3&scoped=true&"
import script from "./ProductBaseStock.vue?vue&type=script&lang=js&"
export * from "./ProductBaseStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductBaseStock.vue?vue&type=style&index=0&id=433bf7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bf7f3",
  null
  
)

export default component.exports